import { STATUS_ACTIVE } from '@vindr/services/constants/common.constant';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';


const STATUS = [
  { name: 'Inactive', value: 0 },
  { name: 'Active', value: 1 },
  { name: 'Expired', value: 2 },
];

const STATUS_ACTIVE_LIST = [
  { name: 'Active', value: STATUS_ACTIVE.ACTIVE },
  { name: 'Inactive', value: STATUS_ACTIVE.INACTIVE },
];

const LIST_RENDER = {
  status: STATUS,
  active: STATUS_ACTIVE_LIST,
};

interface Status extends FormItemProps {
  typeList: 'status' | 'active';
}

const Status = ({
  name,
  label = 'Status',
  placeholder = 'Select Status',
  rules,
  typeList,
  required,
  ...props
}: Status) => {
  const { t } = useTranslation('Vindoc');

  if (!name) {
    name = typeList === 'active' ? 'active' : 'status';
  }

  return (
    <FormSelect
      {...{ name, label, placeholder }}
      {...(rules && { rules })}
      allowClear={false}
      required={required}
      {...props}
    >
      {LIST_RENDER[typeList]?.map((st) => (
        <Select.Option key={st.value} value={st.value}>
          {t(st.name)}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Status;
